import { emitWeatherError, hasWeatherNumber, hasWeatherText, errorHitNearbyCities, errorHitNearbyAirports } from '../errorhit';

const families = {
  'temperature-min': 'temperature', 'temperature-max': 'temperature',
  'thermal-min': 'thermal-sensation', 'thermal-max': 'thermal-sensation',
  'rain-precipitation': 'precipitation', 'rain-probability': 'precipitation-probability',
  'humidity': 'humidity', 'humidity-min': 'humidity', 'humidity-max': 'humidity',
  'wind': 'wind-velocity', 'wind-direction': 'wind-direction', 'gust': 'gust', 'sunrise': 'sun', 'sunset': 'sun',
  'sun': 'sun', 'moon': 'moon-phase', 'period-icon': 'icon_period',
  'condition': 'condition', 'rainbow': 'rainbow',
};

// Observe the fields rendered by these cards, including initially closed days.
// Group min/max and period icons exactly as the existing per-family events do.
export function reportWeatherSummaryErrors() {
  const cards = [...document.querySelectorAll('[data-weather-summary-index]')];
  const current = [...document.querySelectorAll('[data-weather-current-field]')];
  const currentText = [...document.querySelectorAll('[data-weather-current-text-field]')];
  if (!cards.length && !current.length && !currentText.length) return;
  for (const card of cards) {
    const missing = new Set();
    card.querySelectorAll('[data-weather-unavailable]').forEach(element => {
      const key = element.getAttribute('data-weather-unavailable').replace(/^daily-field-/, '');
      if (families[key]) missing.add(families[key]);
    });
    card.querySelectorAll('[data-weather-number]').forEach(element => {
      if (!hasWeatherNumber(element.getAttribute('data-weather-number'))) {
        const family = families[element.getAttribute('data-weather-field')];
        if (family) missing.add(family);
      }
    });
    card.querySelectorAll('[data-weather-text][data-weather-field]').forEach(element => {
      if (!hasWeatherText(element.getAttribute('data-weather-text'))) {
        const family = families[element.getAttribute('data-weather-field')];
        if (family) missing.add(family);
      }
    });
    const index = card.getAttribute('data-weather-summary-index');
    missing.forEach(family => emitWeatherError(family === 'icon_period'
      ? `data_aggregator_forecast_icon_period_${index}`
      : `data_aggregator_forecast_${family}_daily_${index}`));
  }
  current.forEach(element => {
    if (!hasWeatherNumber(element.getAttribute('data-weather-number'))) {
      emitWeatherError(`data_aggregator_now_${element.getAttribute('data-weather-current-field')}`);
    }
  });
  currentText.forEach(element => {
    if (!hasWeatherText(element.getAttribute('data-weather-text'))) {
      emitWeatherError(`data_aggregator_now_${element.getAttribute('data-weather-current-text-field')}`);
    }
  });
  errorHitNearbyCities();
  errorHitNearbyAirports();
}

export default function initializeWeatherSummaryTelemetry() {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reportWeatherSummaryErrors, { once: true });
  } else {
    reportWeatherSummaryErrors();
  }
}
